// extracted by mini-css-extract-plugin
export default {"SubTitle":"DevicesForm_SubTitle__ziePs","SubDivider":"DevicesForm_SubDivider__i-Lhe"};